import { BadgeArtSelectorModel } from '../../../../../shared/kiosk';
import { AbstractElementEditor } from './AbstractElementEditor';

export class BadgeArtSelectorEditor extends AbstractElementEditor<BadgeArtSelectorModel> {
  public getDescription(): string {
    return 'Allow user to choose background picture for their badge';
  }

  public getName(): string {
    return 'Badge Art Selector';
  }

  public getIcon(): string {
    return 'brush';
  }
}
